import { render, staticRenderFns } from "./ProcedureVersionBadge.vue?vue&type=template&id=0f1b9f24&scoped=true"
import script from "./ProcedureVersionBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcedureVersionBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProcedureVersionBadge.vue?vue&type=style&index=0&id=0f1b9f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b9f24",
  null
  
)

export default component.exports